angular.module("avant.customer_applications.factories").factory "RequestTimestamp", [
  "$q",
  ($q) ->
    h =
      request: (config) ->
        # possibly make regex more sophisticated overtime
        # goal is to bust cache in older browsers like IE
        regex_matchers = [/.*\/api\/.*/]
        if config?.method && config?.url && config.method is "GET" and _.some(regex_matchers, (matcher) -> matcher.test(config.url))
          extra_char = if $.inArray('?', config.url) is -1 then '?' else '&'
          config.url += "#{extra_char}request_timestamp=#{$.now()}"
        config || $q.when(config)
    h
]